import first from 'lodash/first';
export const _first = first;
